export { SectionCard } from './SectionCard';
export type { SectionCardProps } from './SectionCard';
